(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2361,5664],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Frank%2Findex.tsx&page=%2Frank!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rank",
      function () {
        return __webpack_require__("./src/pages/rank/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/pages/rank/RankHero.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");



const RankHero = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
        py: {
            md: 20,
            base: 24
        },
        w: {
            lg: "80%",
            md: "80%",
            base: "95%",
            "2xl": "80%"
        },
        mx: "auto",
        flexDir: "column",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                fontSize: {
                    lg: "6xl",
                    md: "4xl",
                    base: "2xl",
                    "2xl": "7xl"
                },
                mb: {
                    base: 6
                },
                children: "RANKING BY MARKETCAP"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                mt: {
                    md: 4
                },
                fontSize: {
                    "2xl": "2xl",
                    md: "xl",
                    base: "md"
                },
                textAlign: "center",
                children: "A list of wikis in different categories, including DeFi, NFTs, DAOs and Cryptocurrencies, ranked based on the global marketcap respectively."
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (RankHero);


/***/ }),

/***/ "./src/pages/rank/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ rank; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tabs/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tabs/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/table/dist/index.esm.js
var table_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/table/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__("./node_modules/react-icons/bi/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
;// CONCATENATED MODULE: ./src/components/SEO/Rank.tsx



const RankHeader = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: "Ranking by Market Capital for NFT and TOKENS",
        description: "Live update for nft and tokens marketcap",
        canonical: "https://iq.wiki/rank",
        openGraph: {
            title: "Rank- MarketCap",
            description: "Live update for nft and tokens marketcap"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
/* harmony default export */ var Rank = (RankHeader);

// EXTERNAL MODULE: ./src/components/Rank/RankButton.tsx
var RankButton = __webpack_require__("./src/components/Rank/RankButton.tsx");
// EXTERNAL MODULE: ./src/components/Rank/RankTable.tsx + 3 modules
var RankTable = __webpack_require__("./src/components/Rank/RankTable.tsx");
// EXTERNAL MODULE: ./src/services/ranking/index.tsx + 1 modules
var ranking = __webpack_require__("./src/services/ranking/index.tsx");
// EXTERNAL MODULE: ./src/components/Rank/InvalidRankCardItem.tsx
var InvalidRankCardItem = __webpack_require__("./src/components/Rank/InvalidRankCardItem.tsx");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var skeleton_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/skeleton/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Rank/LoadingRankCardSkeleton.tsx



const SingularSkeleton = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm.Tr, {
        verticalAlign: "middle",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                verticalAlign: "middle",
                borderColor: "rankingListBorder",
                pr: "1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                    h: "12px",
                    w: "36px",
                    borderRadius: "15px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                borderColor: "rankingListBorder",
                pl: "2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    gap: "2.5",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: "40px",
                            w: "40px",
                            borderRadius: "50%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    h: "15px",
                                    w: "180px",
                                    borderRadius: "15px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    h: "12px",
                                    w: "36px",
                                    borderRadius: "15px",
                                    mt: "1"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                verticalAlign: "middle",
                borderColor: "rankingListBorder",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: "15px",
                            w: "80px",
                            borderRadius: "15px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: "10px",
                            w: "30px",
                            borderRadius: "15px"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                verticalAlign: "middle",
                borderColor: "rankingListBorder",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: "15px",
                            w: "80px",
                            borderRadius: "15px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: "10px",
                            w: "30px",
                            borderRadius: "15px"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                verticalAlign: "middle",
                borderColor: "rankingListBorder",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                    h: "15px",
                    w: "80px",
                    borderRadius: "15px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                verticalAlign: "middle",
                borderColor: "rankingListBorder",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                    h: "15px",
                    w: "60px",
                    borderRadius: "15px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                verticalAlign: "middle",
                borderColor: "rankingListBorder",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                    h: "15px",
                    w: "60px",
                    borderRadius: "15px"
                })
            })
        ]
    });
};
const LoadingRankCardSkeleton = (param)=>{
    let { length  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: Array.from({
            length
        }).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SingularSkeleton, {}, index))
    });
};

// EXTERNAL MODULE: ./src/components/Rank/RankCardItem.tsx + 1 modules
var RankCardItem = __webpack_require__("./src/components/Rank/RankCardItem.tsx");
// EXTERNAL MODULE: ./src/pages/rank/RankHero.tsx
var RankHero = __webpack_require__("./src/pages/rank/RankHero.tsx");
;// CONCATENATED MODULE: ./src/pages/rank/index.tsx













const LISTING_LIMITS = 20;
const rank_Rank = (param)=>{
    let { totalTokens , totalNfts  } = param;
    const [nftOffset, setNftOffset] = (0,react.useState)(1);
    const [tokensOffset, setTokensOffset] = (0,react.useState)(1);
    const [tokenCount, setTokenCount] = (0,react.useState)(0);
    const [nftCount, setNftCount] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        setTokenCount(tokensOffset * LISTING_LIMITS - LISTING_LIMITS);
        setNftCount(nftOffset * LISTING_LIMITS - LISTING_LIMITS);
    }, [
        nftOffset,
        tokensOffset
    ]);
    const { data: tokensObject , isFetching  } = (0,ranking/* useGetTokenRankingQuery */.TO)({
        kind: "TOKEN",
        offset: tokensOffset,
        limit: LISTING_LIMITS
    });
    const { data: nftsObject , isFetching: NFTisFetching  } = (0,ranking/* useGetNFTRankingQuery */.NA)({
        kind: "NFT",
        offset: nftOffset,
        limit: LISTING_LIMITS
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rank, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                bg: "url(/images/backgrounds/ranking-bg-light.png)",
                _dark: {
                    bg: "url(/images/backgrounds/ranking-bg-dark.png)"
                },
                bgPos: "center",
                my: -2,
                bgSize: "cover !important",
                bgColor: "#F7FAFC",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RankHero["default"], {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                maxW: {
                    base: "100%",
                    "2xl": "1280px",
                    md: "95%"
                },
                mx: "auto",
                py: 16,
                flexWrap: "wrap",
                gap: {
                    base: 10,
                    md: 0,
                    lg: 4
                },
                justifyContent: {
                    lg: "center",
                    md: "space-between"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Tabs */.mQ, {
                    w: "full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* TabList */.td, {
                                border: "none",
                                display: "flex",
                                gap: {
                                    base: "5",
                                    md: "8"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RankButton/* default */.Z, {
                                        label: "Cryptocurrencies",
                                        icon: ri_index_esm/* RiCoinsFill */.SSK,
                                        fontSize: {
                                            lg: "20px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RankButton/* default */.Z, {
                                        label: "NFTs",
                                        icon: bi_index_esm/* BiImage */.ntj,
                                        fontSize: {
                                            lg: "20px"
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* TabPanels */.nP, {
                            mt: "6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* TabPanel */.x4, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            color: "homeDescriptionColor",
                                            fontSize: {
                                                base: "lg",
                                                lg: 22
                                            },
                                            mx: "auto",
                                            mb: 9,
                                            px: 4,
                                            textAlign: "center",
                                            maxW: "750",
                                            children: "Cryptocurrency wikis ranked by Market Cap Prices"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankTable/* RankTable */.v, {
                                            hasPagination: true,
                                            currentPage: tokensOffset,
                                            totalCount: totalTokens,
                                            pageSize: LISTING_LIMITS,
                                            onPageChange: (page)=>setTokensOffset(page),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RankTable/* RankTableHead */._, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm/* Tbody */.p3, {
                                                    children: isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRankCardSkeleton, {
                                                        length: 20
                                                    }) : tokensObject === null || tokensObject === void 0 ? void 0 : tokensObject.map((token, index)=>token ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RankCardItem/* default */.Z, {
                                                            index: tokenCount + index,
                                                            item: token
                                                        }, token.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InvalidRankCardItem/* InvalidRankCardItem */.D, {
                                                            index: tokenCount + index
                                                        }, "invalid-token".concat(index)))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* TabPanel */.x4, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            color: "homeDescriptionColor",
                                            fontSize: {
                                                base: "lg",
                                                lg: 22
                                            },
                                            mx: "auto",
                                            mb: 9,
                                            px: 4,
                                            textAlign: "center",
                                            maxW: "750",
                                            children: "NFT wikis ranked by Market Cap Prices"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankTable/* RankTable */.v, {
                                            hasPagination: true,
                                            currentPage: nftOffset,
                                            totalCount: totalNfts,
                                            pageSize: LISTING_LIMITS,
                                            onPageChange: (page)=>setNftOffset(page),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RankTable/* RankTableHead */._, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm/* Tbody */.p3, {
                                                    children: NFTisFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRankCardSkeleton, {
                                                        length: 20
                                                    }) : nftsObject === null || nftsObject === void 0 ? void 0 : nftsObject.map((nft, index)=>nft ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RankCardItem/* default */.Z, {
                                                            index: index + nftCount,
                                                            item: nft
                                                        }, nft.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InvalidRankCardItem/* InvalidRankCardItem */.D, {
                                                            index: index + nftCount
                                                        }, "invalid-nft-".concat(index)))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var rank = (rank_Rank);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,3874,5675,2192,7249,8764,5619,4095,8283,467,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Frank%2Findex.tsx&page=%2Frank!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);